function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return { value: void 0, done: !0 }; } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable || "" === iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } throw new TypeError(_typeof(iterable) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { finectAPI } from '@finect/front-utils/finectAPI';
var Applications = function () {
  function Applications(appID) {
    var _this = this;
    _classCallCheck(this, Applications);
    _defineProperty(this, "appID", null);
    _defineProperty(this, "sessionID", null);
    _defineProperty(this, "status", 'uncompleted');
    _defineProperty(this, "fields", []);
    _defineProperty(this, "latest", null);
    _defineProperty(this, "created", null);
    _defineProperty(this, "updated", null);
    _defineProperty(this, "toObject", function (fields) {
      var object = {};
      for (var i = 0; i < fields.length; i++) {
        var field = _this.getField(fields[i]);
        if (field) {
          object[fields[i]] = field.value;
        }
      }
      return object;
    });
    _defineProperty(this, "getField", function (fieldName) {
      return _this.fields.find(function (field) {
        return field.field === fieldName;
      });
    });
    _defineProperty(this, "getSessionID", function () {
      return _this.sessionID;
    });
    _defineProperty(this, "setStatus", function (status) {
      _this.status = status;
      return _this;
    });
    _defineProperty(this, "setFieldValue", function (fieldName, fieldValue, defaultValue) {
      var field = _this.getField(fieldName);
      if (field) {
        for (var i = 0; i < _this.fields.length; i++) {
          if (_this.fields[i].field === fieldName) {
            _this.latest = fieldName;
            _this.fields[i].value = fieldValue;
            _this.fields[i].clean = false;
          }
        }
      } else {
        _this.latest = fieldName;
        _this.fields.push({
          field: fieldName,
          value: fieldValue,
          default: typeof defaultValue !== 'undefined' ? defaultValue : null,
          clean: false
        });
      }
      return _this;
    });
    _defineProperty(this, "updateFieldValue", function (fieldName) {
      if (!_this.sessionID) return false;
      finectAPI({
        version: 'v4',
        path: "applications/".concat(_this.appID, "/sessions/").concat(_this.sessionID),
        method: 'PUT',
        referrerPolicy: 'no-referrer-when-downgrade',
        credentials: 'include',
        body: {
          status: 'uncompleted',
          items: _this.getField(fieldName)
        }
      });
    });
    _defineProperty(this, "setFields", function (fields) {
      for (var i = 0; i < fields.length; i++) {
        _this.setFieldValue(fields[i].field, fields[i].value, typeof fields[i].default !== 'undefined' ? fields[i].default : null);
      }
      return _this;
    });
    _defineProperty(this, "reset", function () {
      _this.sessionID = null;
      _this.fields = [];
      _this.status = null;
      _this.created = null;
      _this.updated = null;
      return _this;
    });
    _defineProperty(this, "emptyFields", function () {
      _this.fields = [];
      return _this;
    });
    _defineProperty(this, "removeField", function (fieldName) {
      _this.fields = _this.fields.filter(function (field) {
        return field.field !== fieldName;
      });
      return _this;
    });
    _defineProperty(this, "getBody", function (latest) {
      return {
        status: _this.status,
        items: latest ? _this.fields.filter(function (field) {
          return field.field === _this.latest;
        }).map(function (field) {
          return field;
        }) : _this.fields.filter(function (field) {
          return field.value !== null && field.clean === false;
        }).map(function (field) {
          return {
            field: field.field,
            value: field.type == 'number' ? Number(field.value) : field.value,
            default: field.default
          };
        })
      };
    });
    _defineProperty(this, "send", function () {
      return Promise.resolve(!_this.sessionID ? _this.post() : _this.put());
    });
    _defineProperty(this, "sendLatest", function () {
      if (!_this.sessionID) {
        _this.post();
      } else {
        _this.put(true);
      }
    });
    _defineProperty(this, "get", function () {
      var tracking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var _onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var url = tracking ? "applications/".concat(_this.appID, "/sessions/last?tracking=").concat(tracking) : "applications/".concat(_this.appID, "/sessions/last");
      finectAPI({
        version: 'v4',
        path: url,
        method: 'GET',
        credentials: 'include',
        onSuccess: function onSuccess(response) {
          if (response.code === 200) {
            _this.sessionID = response.data.id;
            _this.fields = response.data.items;
            _this.status = response.data.status;
            _this.created = response.data.created || null;
            _this.updated = response.data.updated || null;
          }
          _onSuccess(response, _this);
        },
        onError: function onError(response) {
          _onError(response);
        }
      });
    });
    _defineProperty(this, "getSettings", function () {
      var _onSuccess2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var _onError2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var url = "applications/".concat(_this.appID, "/settings");
      finectAPI({
        version: 'v4',
        path: url,
        method: 'GET',
        credentials: 'include',
        onSuccess: function onSuccess(response) {
          if (response.code === 200) {
            console.log(response.data.fields);
            _this.fields = response.data.fields.map(function (field) {
              return {
                field: field.field,
                type: field.type,
                format: field.format,
                application: field.lastValue ? field.lastValue.application.id : null,
                value: field.lastValue ? field.lastValue.value : null,
                default: field.lastValue ? field.lastValue.value : null,
                clean: true
              };
            });
            _onSuccess2(response);
          }
        },
        onError: function onError(response) {
          _onError2(response);
        }
      });
    });
    _defineProperty(this, "findSession", function () {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _onSuccess3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var _onError3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
      _this.reset();
      var url = "applications/".concat(_this.appID, "/sessions");
      var session = null;
      finectAPI({
        version: 'v4',
        path: url,
        method: 'GET',
        credentials: 'include',
        onSuccess: function onSuccess(response) {
          response.data.forEach(function (app) {
            var found = app.items.find(function (item) {
              return app.status === 'completed' && item.field === field && item.value === value;
            });
            if (found) {
              session = app;
              _this.sessionID = app.id;
              _this.fields = app.items;
              _this.status = app.status;
              _this.created = app.created || null;
              _this.updated = app.updated || null;
            }
          });
          _onSuccess3(session);
        },
        onError: function onError(response) {
          _onError3(response);
        }
      });
    });
    _defineProperty(this, "post", _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return finectAPI({
              version: 'v4',
              path: "applications/".concat(_this.appID, "/sessions"),
              method: 'POST',
              referrerPolicy: 'no-referrer-when-downgrade',
              body: _this.getBody(),
              credentials: 'include',
              onSuccess: function onSuccess(data) {
                if (data.code === 201) {
                  _this.sessionID = data.data.id;
                  return {
                    code: 201
                  };
                }
              },
              onError: function onError(error) {
                return {
                  code: error.status,
                  method: 'POST'
                };
              }
            });
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(this, "put", function () {
      var _ref2 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(latest) {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return finectAPI({
                version: 'v4',
                path: "applications/".concat(_this.appID, "/sessions/").concat(_this.sessionID),
                method: 'PUT',
                referrerPolicy: 'no-referrer-when-downgrade',
                credentials: 'include',
                body: _this.getBody(latest),
                onSuccess: function onSuccess(data) {
                  if (data.code === 200) {
                    _this.updated = data.data.updated || null;
                    return {
                      code: 200
                    };
                  }
                },
                onError: function onError(error) {
                  return {
                    code: error.status,
                    method: 'PUT'
                  };
                }
              });
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", response);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    this.appID = appID;
    this.fields = [];
    this.status = 'uncompleted';
    this.latest = null;
    this.created = null;
    this.updated = null;
  }
  _createClass(Applications, null, [{
    key: "load",
    value: function load(appID) {
      var _this2 = this;
      return finectAPI({
        version: 'v4',
        path: "applications/".concat(appID, "/sessions/last"),
        method: 'GET',
        credentials: 'include',
        onSuccess: function onSuccess(response) {
          if (response.code === 200) {
            var instance = new _this2(appID);
            instance.sessionID = response.data.id;
            instance.fields = response.data.items;
            instance.status = response.data.status;
            instance.created = response.data.created || null;
            instance.updated = response.data.updated || null;
            return instance;
          }
        },
        onError: function onError(response) {
          return new _this2(appID);
        }
      });
    }
  }, {
    key: "loadFromAPIResponse",
    value: function loadFromAPIResponse(response) {
      var instance = new this(response.application.id);
      instance.sessionID = response.application.id;
      instance.fields = response.items;
      instance.status = response.status;
      instance.created = response.created || null;
      instance.updated = response.updated || null;
      return instance;
    }
  }]);
  return Applications;
}();
export { Applications };